module.exports = __webpack_public_path__ + "static/media/Save.4ad650bf.jpeg";